import { createIpNavService } from '@patsnap-biz/ip-nav';
import { useHeaderService } from '@/presentation/composables/use-header-service';
import { injectService, PsHttp } from '@patsnap/tahiti-core';
import { useCommands } from '@telecom/shared/composables/use-commands';
import { createSharedComposable } from '@vueuse/core';
import { EditionType } from '@/features/plg-plan/types';
import { useUserInfo } from '@telecom/shared/domain/permission/composables/use-user-info';

/**
 * IP 导航服务 composable
 * 提供统一的 ipNavService 实例，用于导航组件
 */
export const useIpNavService = createSharedComposable(() => {
    const { headerService } = useHeaderService();
    const { executeCommand } = useCommands();
    const psHttp = injectService(PsHttp) as any;
    const { isFreeUser } = useUserInfo();

    // 创建适配器，将 psHttp 函数转换为 IAxiosClient 接口
    const httpClientAdapter = {
        get: async (config: { url: string; params?: any; [key: string]: any }) => {
            const response = await psHttp({ method: 'GET', ...config });
            return response.data;
        },
        post: async (config: { url: string; data?: any; [key: string]: any }) => {
            const response = await psHttp({ method: 'POST', ...config });
            return response.data;
        },
        delete: async (config: { url: string; data?: any; [key: string]: any }) => {
            const response = await psHttp({ method: 'DELETE', ...config });
            return response.data;
        },
    };

    const ipNavService = createIpNavService({
        headerService: headerService as any,
        httpClient: httpClientAdapter as any,
        apiBaseUrl: import.meta.env.VITE_EUREKA_SERVICE_URI,
        onUpgrade() {
            // 能看看这个升级的都是免费版本,所以推荐升级成PRO
            executeCommand('plg:open-plan-list-dialog', {
                recommendedPlanId: EditionType.PRO,
                trigger_source: 'side_nav',
            });
        },
        onLogin() {
            executeCommand('login:open-dialog');
        },
        isShowUpgrade() {
            return isFreeUser.value;
        },
    });

    return { ipNavService, headerService };
});
